// extracted by mini-css-extract-plugin
export default {"radios":"LS0yd"};